import { IDmLoaiThuBoSungKienThucRequest } from "./../../../model/request/category/dmLoaiThuBoSungKienThucRequest";
import { IDmLoaiThuBoSungKienThucActionTypes } from "../../action-types/category/IDmLoaiThuBoSungKienThucActions";
import { IDmLoaiThuBoSungKienThucReducer } from "../../reducer-model/category/IDmLoaiThuBoSungKienThucReducer";
import { eReducerStatusBase } from "./../../reducer-model/eReducerStatusBase";
import { eMode } from "../../../content/enum";
const iniState: IDmLoaiThuBoSungKienThucReducer = {
  status: eReducerStatusBase.is_not_initialization,
  loaiThuBoSungKienThucs: [],
  idSelections: [],
  heNganhs: [],
  loaiThuBoSungKienThucTheoDots: [],
  mode: eMode.xem,
  request: {
    dot: 0,
  } as IDmLoaiThuBoSungKienThucRequest,
};
export const loaiThuBoSungKienThucReducer = (
  state: IDmLoaiThuBoSungKienThucReducer = iniState,
  action: IDmLoaiThuBoSungKienThucActionTypes,
): IDmLoaiThuBoSungKienThucReducer => {
  switch (action.type) {
    case "LOAI_THU_BO_SUNG_KIEN_THUC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        idSelections: [],
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        loaiThuBoSungKienThucs: action.payload,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
        loaiThuBoSungKienThucs: [
          ...state.loaiThuBoSungKienThucs.filter(
            (x) => x.id_thu_chi_main !== action.payload.id_thu_chi_main,
          ),
          action.payload,
        ],
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
        status: eReducerStatusBase.is_need_reload,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        loaiThuBoSungKienThucEditing: action.payload,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        loaiThuBoSungKienThucEditing: undefined,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_DELETE_MANY_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_DELETE_MANY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_DELETE_MANY_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_LOAD_HE_NGANH_START":
      return {
        ...state,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_LOAD_HE_NGANH_SUCCESS":
      return {
        ...state,
        heNganhs: action.payload,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_LOAD_HE_NGANH_ERRR":
      return {
        ...state,
        heNganhs: [],
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_LOAD_THEO_DOT_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_LOAD_THEO_DOT_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        loaiThuBoSungKienThucTheoDots: action.payload,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_LOAD_THEO_DOT_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_SAVE_MULTIPLE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_SAVE_MULTIPLE_SUCCESS":
      const updatedIds = action.payload.map((x) => x.id_thu_chi_main);
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        loaiThuBoSungKienThucTheoDots: [
          ...state.loaiThuBoSungKienThucTheoDots.filter(
            (x) => !updatedIds.includes(x.id_thu_chi_main),
          ),
          ...action.payload,
        ],
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_SAVE_MULTIPLE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_BO_SUNG_KIEN_THUC_CHANGE_VALUE":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
